import { getLocalApi } from "./localApi";
import { Port, Terminal, TransferInstruction } from "app/shared/model/Port";
import apiConfig from "app/api/apiConfig.json";

const PORT_TYPE_MAP: Record<number, string> = {
  1: "Airport",
  2: "Train Station",
};

function asPositiveNumber(value: unknown, fallback: number): number {
  const parsed = Number(value);
  if (Number.isFinite(parsed) && parsed > 0) {
    return parsed;
  }
  return fallback;
}

function mapTerminal(portId: number, t: any, idx: number): Terminal {
  const number = asPositiveNumber(t?.number, idx + 1);
  const order = asPositiveNumber(t?.order, number);
  const syntheticId = portId * 1000 + number;

  return {
    id: syntheticId,
    name: String(t?.name ?? "").trim(),
    number,
    active: Boolean(t?.isActive),
    order,
  };
}

function mapTransferInstruction(ti: any): TransferInstruction {
  return {
    divisionId: Number(ti?.divisionId ?? 0),
    instructions: String(ti?.instructions ?? "").trim(),
  };
}

function mapPort(dto: any): Port {
  const id = Number(dto?.id ?? 0);
  const terminalsSrc = Array.isArray(dto?.terminals) ? dto.terminals : [];
  const instructionsSrc = Array.isArray(dto?.transferInstructions) ? dto.transferInstructions : [];

  const terminals = terminalsSrc
    .map((t: any, idx: number) => mapTerminal(id, t, idx))
    .sort((a: Terminal, b: Terminal) => {
      const aOrder = a.order ?? a.number;
      const bOrder = b.order ?? b.number;
      return aOrder - bOrder;
    });

  const transferInstructions = instructionsSrc.map(mapTransferInstruction);

  return {
    id,
    name: String(dto?.name ?? "").trim(),
    type: PORT_TYPE_MAP[Number(dto?.transferPortTypeId)] ?? "Unknown",
    active: Boolean(dto?.isActive),
    terminals,
    transferInstructions,
    entityUpdate: dto.entityUpdate,
    createdBy: dto?.createdBy ?? dto?.CreatedBy ?? undefined,
    lastModifiedBy: dto?.lastModifiedBy ?? dto?.LastModifiedBy ?? undefined,
  };
}

export async function getAllPorts(): Promise<Port[]> {
  const localApi = await getLocalApi();

  const endpoint =
    (apiConfig as any)["get-ports-with-terminals"] ??
    (apiConfig as any).get_ports_with_terminals;

  return await localApi.fetchList(
    endpoint,
    (dto: any) => mapPort(dto),
    "Unable to fetch ports with terminals"
  );
}
